import { render } from "./HeroSettingSystemAbout.vue?vue&type=template&id=28bdda93&scoped=true"
import script from "./HeroSettingSystemAbout.vue?vue&type=script&lang=js"
export * from "./HeroSettingSystemAbout.vue?vue&type=script&lang=js"

import "./HeroSettingSystemAbout.vue?vue&type=style&index=0&id=28bdda93&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bdda93"]])

export default __exports__